import React from 'react';
//interfaces
import { RentabilityProps } from './interface';
//components
import Input from "pages/Quotes/components/generics/Input/Input";
//patterns
import {
  percentageNegativeAndPositive,
  percentageWith3Digits
} from "pages/Quotes/utils/patterns";

export const Rentability: React.FC<RentabilityProps> = (props) => {
  const {
    stock,
    readOnly,
    isEditing,
    setRentability,
    setUpdateUnitPrice,
    handleKeepFactoryPrice,
    setIsAgreementPriceValue,
    convertedRentabilityValue,
    tooltipText
  } = props;

  const patternDigits = !stock?.isPricedAccordingly && !stock?.ol && stock?.olPrice === 0 ? percentageNegativeAndPositive : percentageWith3Digits;

  const handleRentability = (value: string) => {
    value = value.replace(".", "");
    const splittedValue = value.split(',')[1];

    if (splittedValue === "0")
      value = Number(value).toFixed(1);

    setUpdateUnitPrice(false);
    setRentability(value);
    setIsAgreementPriceValue(true);
  };

  return (
    <div className="rent">
      <span className="subtitle">Margem %</span>
      <div className="value" style={{ alignItems: "baseline" }}>
        {!isEditing ? (
          <div className="value">{convertedRentabilityValue}</div>
        ) : (
          <Input
            width="89px"
            type="number"
            isValid={true}
            readOnly={readOnly}
            alt='inputRentability'
            setIsValid={() => { }}
            onChange={(value: any) => {
              handleRentability(value);
            }}
            value={convertedRentabilityValue}
            pattern={patternDigits}
            onBlur={(!stock?.isPricedAccordingly && !stock?.ol && stock?.olPrice === 0) && handleKeepFactoryPrice}
            tooltipText={tooltipText}
          />
        )}
      </div>
    </div>
  );
};